// Ninja Super Theme - dark only
const ninjaSuper = {
  id: 'ninjaSuper',
  name: 'Ninja 🥷',
  price: 150,
  main: '#ff4444',
  light: '#ff6b6b',
  dark: '#cc0000',
  bg: '#f5f5f5',
  darkBg: '#121212',
  isSuper: true,
  isDarkTheme: true,
  shape: 'square',
  surfaces: {
    // Light mode (dark-only, fallback)
    lightBg: '#1a1a1a',
    lightPaper: '#2d2d2d',
    lightContainer: '#2d2d2d',
    lightOnSurface: '#f0f0f0',
    lightOnSurfaceVariant: '#aaaaaa',
    lightOutline: '#666666',
    // Dark mode
    containerLowest: '#1a1a1a',
    containerLow: '#0a0a0a',
    container: '#1a1a1a',
    containerHigh: '#2a2a2a',
    containerHighest: '#333333',
    bright: '#3d3d3d',
    onSurface: '#f0f0f0',
    onSurfaceVariant: '#aaaaaa',
    outline: '#666666',
    outlineVariant: '#444444',
    // Button colors — primary
    primaryContainer: '#e12626',
    onPrimaryContainer: '#ffffff',
    // Button colors — secondary (outlined)
    secondaryContainer: '#3d1a1a',
    onSecondaryContainer: '#ff9999',
    // Button colors — secondary (filled)
    secondary: '#ff6b6b',
    onSecondary: '#1a0000',
    secondaryLight: '#cc0000',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#f0f0f0',
    onInverseSurface: '#121212',
    inverseSurfaceLight: '#121212',
    onInverseSurfaceLight: '#f0f0f0',
    // Button colors — label/text
    labelColor: '#ff6b6b',
    labelColorLight: '#cc0000',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#ed6c02',
    warningLight: '#ff9800',
    warningDark: '#e65100',
    error: '#ff4444',
    errorLight: '#ff6b6b',
    errorDark: '#cc0000',
  },
  animations: {
    avatar: 'glowPulse',
    taskComplete: 'sparkle',
    completionGlow: true,
  },
  effects: {
    glowColor: '#ff444460',
    accentGlow: '#ff4444',
  },
  modes: {
    light: {
      bg: '#1a1a1a',
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
      cardBg: 'rgba(255,255,255,0.12)',
      taskCompleteText: '#ffffff',
      completedByOtherBg: 'rgba(255,255,255,0.08)',
    },
    dark: {
      bg: '#121212',
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
      cardBg: 'rgba(255,255,255,0.12)',
      taskCompleteText: '#ffffff',
      completedByOtherBg: 'rgba(255,255,255,0.08)',
    },
  },
};

export default ninjaSuper;
